import { useEffect, useMemo, useState } from "react";
import { partitionByVisibility, type TimeGatedTask } from "@/lib/visibleFrom";

const TICK_MS = 30_000;

export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), TICK_MS);
    return () => clearInterval(id);
  }, []);
  return now;
}

export function useTimeGate<T extends TimeGatedTask>(tasks: T[]) {
  const now = useNow();
  const [revealed, setRevealed] = useState(false);
  const { shown, hidden } = useMemo(() => partitionByVisibility(tasks, now), [tasks, now]);

  return {
    shown: revealed ? tasks : shown,
    hiddenCount: hidden.length,
    revealed,
    toggleRevealed: () => setRevealed((v) => !v),
  };
}
